export default __webpack_public_path__ + "static/media/SAS Chat Tone 2.0c7c887e.wav";